// extracted by mini-css-extract-plugin
export default {"load__container":"Loading_load__container__o+yTR","ship":"Loading_ship__eLyEd"};